import { useEffect, useState } from "react";
import { Outlet } from "react-router";

// Importaciones estáticas para mejor rendimiento
import { Sidebar } from "@/components/navigation/sidebar";
import { SidebarLite } from "@/components/navigation/sidebar-lite";
import { Navbar } from "@/components/navigation/navbar";
import { NavbarLite } from "@/components/navigation/navbar-lite";
import { FooterNav } from "@/pages/menu/FooterNav";
import { FooterNavLite } from "@/pages/menu/FooterNavLite";

// Detección móvil simplificada
function useSimpleMobileDetector() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  return { isMobile };
}

export function MainLayout() {
  const { isMobile } = useSimpleMobileDetector();

  // Selección simple de componentes basada en el tamaño de pantalla
  const SidebarComp = isMobile ? SidebarLite : Sidebar;
  const NavbarComp = isMobile ? NavbarLite : Navbar;
  const FooterComp = isMobile ? FooterNavLite : FooterNav;

  return (
    <>
      {/* Estilos simplificados para mejor rendimiento */}
      <style>{`
        .main-layout {
          background: #ffffff;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
        }
        
        @media (prefers-contrast: high), (prefers-contrast: more), (-ms-high-contrast: active) {
          .main-layout {
            background: #ffffff !important;
            border: 1px solid #000000 !important;
          }
          
          .main-layout main {
            background: #ffffff !important;
          }
        }
      `}</style>

      <div className="main-layout flex h-screen">
        <SidebarComp />
        <main className="flex-1 px-0 pt-0 pb-2 overflow-auto bg-base-100">
          <NavbarComp />
          <Outlet />
        </main>
        <FooterComp />
      </div>
    </>
  );
}
